import { RouteConfig } from "vue-router";

const codCuentas: RouteConfig = {
  path: "/codCuentas",
  name: "codCuentas",
  component: () => import(/* webpackChunkName: "cod-cuentas" */ "@/views/CodCuentas.vue"),
};

export default codCuentas;
